import { filterActiveProducts } from '@paradigm/features/src/unified-rfqs/ui/rfq-filters/active-products-tabs-context';
import {
  MAIN_TAB_ID,
  TabsState,
} from '@paradigm/features/src/unified-rfqs/ui/rfq-filters/tabs-context';
import {
  hasConflictingProductSelection,
  INITIAL_STATE,
} from '@paradigm/features/src/unified-rfqs/ui/rfq-filters/filter-provider';
import { RfqFilters } from '@paradigm/features/src/unified-rfqs/services/rfq-filtering';

/**
 * Where the markets page keeps each tab's filter. Kept out of `UnifiedRfqs`
 * so the app shell can read the filter without pulling in the lazily loaded
 * page.
 */
export const TAB_FILTERS_STORAGE_KEY = 'unified-rfq-tab-filters';

export const tabFiltersStorageKey = (userId: string | number) =>
  `${userId}:${TAB_FILTERS_STORAGE_KEY}`;

/**
 * The filter of the tab the markets page opens on. The page always starts on
 * the main tab, so that is the filter deciding what the user would see if they
 * opened it right now.
 *
 * Anything read here reaches the app shell, so it must survive whatever is on
 * disk: a stored filter is never migrated, and one saved before a field
 * existed comes back without it.
 */
export function selectStoredMainTabFilter(
  tabsState: TabsState | null,
): RfqFilters | null {
  const mainTab = tabsState?.entities[MAIN_TAB_ID];
  if (mainTab?.filter == null) return null;

  const { filter } = filterActiveProducts({
    ...mainTab,
    filter: { ...INITIAL_STATE, ...mainTab.filter },
  });
  if (filter == null) return null;

  return {
    auctionTypes: filter.auctionTypes,
    productCodes: filter.productCodes,
    strategyCodes: filter.strategyCodes,
    notional: filter.notional,
    counterparties: filter.counterparties.map((option) => option.value),
    hasConflictingProductSelection: hasConflictingProductSelection(filter),
  };
}
